import { Fragment } from "react";

const ITEMS = ["Live 1:1", "Real-Time Correction", "Recover", "Build", "Perform", "Longevity"];

function Row() {
  return (
    <span className="flex items-center whitespace-nowrap">
      {[...ITEMS, ...ITEMS].map((it, i) => (
        <Fragment key={i}>
          <span className="font-display text-2xl font-black uppercase tracking-tight text-bone sm:text-4xl">
            {it}
          </span>
          <span className="mx-8 font-display text-2xl text-lime sm:mx-12 sm:text-4xl">·</span>
        </Fragment>
      ))}
    </span>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-y border-bone/10 bg-ink py-6"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
